import type { TypedDocumentNode } from '@apollo/client';
import { gql } from '@apollo/client';

import type { Sport } from '#src/__generated__/globalTypes.ts';
import { PromoBanner } from '#src/components/onboarding/PromoBanner/index.tsx';
import { useQuery } from '#src/hooks/graphql/useQuery.ts';
import { useLocalStorage } from '#src/hooks/useLocalStorage.ts';

import type {
  SignupPromoBannerQuery,
  SignupPromoBannerQueryVariables,
} from './__generated__/index.graphql.ts';

const SIGNUP_PROMO_BANNER_QUERY = gql`
  query SignupPromoBannerQuery($sport: Sport!, $affiliate: Boolean!) {
    market {
      id
      onboardingConversionCredit(sport: $sport, affiliate: $affiliate) {
        id
        ...PromoBanner_conversionCredit
      }
    }
  }
  ${PromoBanner.fragments.conversionCredit}
` as TypedDocumentNode<SignupPromoBannerQuery, SignupPromoBannerQueryVariables>;

export const SignupPromoBanner = ({ sport }: { sport: Sport }) => {
  const [utmCampaign] = useLocalStorage('UTM_CAMPAIGN', undefined);
  const [referrerIsAffiliate] = useLocalStorage('REFERRER_IS_AFFILIATE', false);
  const { data } = useQuery(SIGNUP_PROMO_BANNER_QUERY, {
    variables: {
      sport,
      affiliate: !!utmCampaign || referrerIsAffiliate,
    },
    // should already be fetched in landing page
    fetchPolicy: 'cache-first',
  });
  const onboardingConversionCredit = data?.market.onboardingConversionCredit;
  if (!onboardingConversionCredit) {
    return null;
  }
  return (
    <PromoBanner leftAligned conversionCredit={onboardingConversionCredit!} />
  );
};
